import {FormattedMessage} from 'react-intl';
import {useContext, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import messages from '@super-template/messages';
import {ExpandMore} from '@material-ui/icons';
import {Accordion, AccordionDetails, AccordionSummary, Button, Paper, Typography} from '@material-ui/core';
import {SettingsContext} from "../application/utils";
import getTranslated from "@super-template/core/src/locale/getTranslated";
import useLocale from "@super-template/core/src/locale/useLocale";
import ReactHtmlParser from "react-html-parser";

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.primary.light,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[0],
    marginBottom: theme.spacing(4)
  },
  details: {
    display: "block",
  },
  paper: {
    padding: theme.spacing(2),
    '& p': {
      margin: 0
    }
  },
  inline: {
    [theme.breakpoints.up('sm')]: {
      display: 'inline'
    },
  },
  inline_bold: {
    display: 'inline',
    fontFamily: theme.typography.bold,
    marginRight: theme.spacing(1)
  },
  close: {
    width: '100%'
  }
}));

export default function Instructions({isMobile}) {
  const classes = useStyles();
  const isOpen = sessionStorage.getItem('instructions') === 'open';
  const [locale] = useLocale();
  const [expanded, setExpanded] = useState(!isMobile && isOpen);
  const {infoTexts} = useContext(SettingsContext);

  const expand = (e, expand) => {
    if (isOpen && !expand) sessionStorage.setItem('instructions', 'closed');
    setExpanded(!!expand);
  };

  return (
    <Accordion className={classes.root} expanded={expanded} onChange={expand}>
      <AccordionSummary expandIcon={<ExpandMore/>} aria-controls="panel-content" id="panel-header">
        <Typography variant="h6" component="h2"><FormattedMessage {...messages.instructions}/></Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Paper variant="outlined" className={classes.paper}>
          {ReactHtmlParser(getTranslated(infoTexts.CALENDAR?.text, locale))}
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
          <Button className={classes.close} onClick={(e) => expand(e, false)}>
            <FormattedMessage {...messages.close_instructions}/>
          </Button>
        </Paper>
      </AccordionDetails>
    </Accordion>
  );
};
